import React, { useContext, useState } from 'react'
import { Dropdown, Modal } from 'react-bootstrap'
import { Avatar, TextField } from '@mui/material'
import dateFormat from 'dateformat'
import { Close, Delete, Edit, MoreVert } from '@material-ui/icons'
import { AuthContext } from '../../context/AuthContext'
import axios from 'axios'
import ENDPOINT from '../../context/EndPoint'
import SecurityHeaders from '../../context/SecurityHeaders'
import SnackbarToast from '../../components/toasts/SnackbarToast'
import { useDispatch } from 'react-redux'

const BountySubmissionItem = ({item,reload}) => {
  const dispatch = useDispatch()
const {user} = useContext(AuthContext);
  const [open, setOpen] = useState({
    open: false,
    message: '',
  type: ''

  });
  const updateSubmission = async (status) => {
    try {
        // Dispatch a loading action
        dispatch({ type: 'LOADING' });

        const data = new FormData();
        data.append('submission_id', item.id);
        data.append('status', status);
        data.append('session', user.SessionId);

        const response = await axios.post(`${ENDPOINT}update-bounty-submission.php`, data, SecurityHeaders);

        if (response.data.status === 'success') {
            // Dispatch a success action
            dispatch({ type: 'DONE_LOADING' });

            setOpen({ open: true, message: 'Submission updated successfully!', type: 'success' });
            reload();
        } else {
            // Dispatch an error action
            dispatch({ type: 'ERROR', payload: response.data.message });

            setOpen({ open: true, message: response.data.message, type: 'error' });
            console.error(response.data.message);
        }
    } catch (error) {
        // Dispatch an error action
        dispatch({ type: 'ERROR', payload: error.message });

        setOpen({ open: true, message: 'An error occurred. Please try again.', type: 'error' });
        console.error(error);
    }
};

  return (
    <>
    <SnackbarToast open={open} handleClose={() => setOpen({open: false})} />
      <tr>
            <td>
              <div className="d-flex align-items-center">
                <div className="avatar-sm">
                  <Avatar src={item.profile_pic} />
                </div>
                <div className="ms-1 ">
                  <h6 className="fs-15 mb-0">
              
                      {item.first_name + " " + item.last_name}
                
                  
                  </h6>
                  <a target='_blank' href={item.submission_url}>
                      Download
                    </a>
                </div>
              </div>
            </td>
            <td>{item.bounty_title}</td>
            <td>{item.company_name}</td>
       
            <td>{item.report}</td>
            <td>{dateFormat(item.submission_date, "dS mmm hh:mm tt")}</td>
            <td>{item.submission_status}</td>
    
            <td>
              <Dropdown className="options-dropdown">
                <Dropdown.Toggle className="bg-white options p-0 w-fit h-fit  border-0" >
                  <MoreVert className="text-dark" />
                </Dropdown.Toggle>
                <Dropdown.Menu>

                    {
                    item.submission_status === "pending" ? (   
                   <>
                        <Dropdown.Item className='text-success' onClick={() => updateSubmission("accepted")} >
                           Accept
                        </Dropdown.Item>
                          <Dropdown.Item className='text-danger' onClick={() => updateSubmission("rejected")} >
                          Reject
                        </Dropdown.Item></>
                    ) : null}
                    
                    {item.submission_status === "accepted" ? (
                      <>
                        <Dropdown.Item className='text-danger' onClick={() => updateSubmission("rejected")} >
                           Reject
                        </Dropdown.Item>
                        <Dropdown.Item className='text-warning' onClick={() => updateSubmission("pending")} >
                           Pending
                        </Dropdown.Item></>
                    ) : null}
                       {item.submission_status === "rejected" ? (
                      <>
                        <Dropdown.Item className='text-success' onClick={() => updateSubmission("accepted")} >
                           Accept
                        </Dropdown.Item>
                        <Dropdown.Item className='text-warning' onClick={() => updateSubmission("pending")} >
                          Pending
                        </Dropdown.Item></>
                    ) : null}
               


    
              
                </Dropdown.Menu>
              </Dropdown>
            </td>
          </tr>
      
    </>
  )
}

export default BountySubmissionItem
